import AttorneyResourceCenterIndex from './AttorneyResourceCenterIndex';

export default AttorneyResourceCenterIndex;
